import request from '@/utils/request'

export const userBatchImport = (data) => {
  return request({
    url: '/mj/mediaRecord/userBatchImport',
    method: 'POST',
    data
  })
}

export const getMediaRecordList = (data) => {
  return request({
    url: '/mj/mediaRecord/getMediaRecordList',
    method: 'POST',
    data
  })
}

export const getMediaRecordByOppId = (data) => {
  return request({
    url: '/mj/mediaRecord/getMediaRecordByOppId',
    method: 'POST',
    params: data
  })
}

export const searchMediaRecordList = (data) => {
  return request({
    url: '/mj/mediaRecord/searchMediaRecordList',
    method: 'POST',
    data
  })
}

export const exportSearchRecord = (data) => {
  return request({
    url: '/mj/exportData/exportSearchRecord',
    method: 'POST',
    data
  })
}

export const createMediaRecord = (data) => {
  return request({
    url: '/mj/mediaRecord/createMediaRecord',
    method: 'POST',
    data
  })
}

export const getYesterdayRecords = (data) => {
  return request({
    url: '/mj/mediaRecord/getYesterdayRecords',
    method: 'POST',
    params: data
  })
}

export const getAllStatement = (data) => {
  return request({
    url: '/mj/mediaStatement/list',
    method: 'POST',
    data
  })
}

export const writeOffMoney = (data) => {
  return request({
    url: '/mj/mediaStatement/writeOffMoney',
    method: 'POST',
    params: data
  })
}

export const searchMediaStatement = (data) => {
  return request({
    url: '/mj/mediaStatement/searchMediaStatement',
    method: 'POST',
    params: data
  })
}

export const payMoney = (data) => {
  return request({
    url: '/mj/mediaStatement/payMoney',
    method: 'POST',
    params: data
  })
}

export const updateBankReceipt = (data) => {
  return request({
    url: '/mj/mediaStatement/bankReceipt',
    method: 'POST',
    params: data
  })
}

export const getMediaRecordByIds = (data) => {
  return request({
    url: '/mj/mediaRecord/getMediaRecordByIds',
    method: 'POST',
    params: data
  })
}

export const getUserRecords = (data) => {
  return request({
    url: '/mj/mediaRecord/getUserRecords',
    method: 'POST',
    params: data
  })
}

export const searchRecords = (data) => {
  return request({
    url: '/mj/mediaRecord/searchRecords',
    method: 'POST',
    params: data
  })
}

export const getCurrentMonthData = () => {
  return request({
    url: '/mj/mediaRecord/getCurrentMonthData',
    method: 'GET',
    responseType: 'blob'
  })
}

export const getLastMonthData = () => {
  return request({
    url: '/mj/mediaRecord/getLastMonthData',
    method: 'GET',
    responseType: 'blob'
  })
}
